import type { Node } from '../../model';
import { convertNodesToQueue } from './convert-nodes-to-queue';

const transformNodeToStepParts = (node: Node<any>): [any, any] => {
  const group: any[] = [];

  const queue = node.parameters.participants.map((p: any) => {
    if (p.type === 'participant-user') {
      return {
        id: p.parameters.user.id,
      };
    }

    if (p.type === 'participant-group') {
      const users = p.parameters.participants.map((u: any) => ({
        id: u.parameters.user.id,
      }));

      group.push({
        name: p.parameters.name,
        requiredApprovals: p.parameters.requiredApprovals,
        users,
      });
      return users;
    }

    throw new Error(
      `transformNodeToStepParts: Unknown participant type: ${p.type}`,
    );
  });

  return [queue.flat(), group];
};

/**
 * Transform node to step parts with split participants and extracted group data
 * @param node to transform
 */
export const convertNodesToDefaultQueue = convertNodesToQueue(
  transformNodeToStepParts,
);
